import {
  SET_SAFETY_PROJECTS,
  CREATE_SAFETY_PROJECT,
  UPDATE_SAFETY_PROJECT,
  DELETE_SAFETY_PROJECT,
  SET_DAILY_FORMS,
  SET_DAILY_FORM_DETAIL,
  SET_SKYCLIMBER_FORMS,
  SET_SKYCLIMBER_FORM_DETAIL,
  SET_TOOLBOX_TALKS,
  UPDATE_TOOLBOX_TALK,
  CREATE_TOOLBOX_TALK,
  SET_SAFETY_DOCUMENTS,
  UPDATE_SAFETY_DOCUMENT,
  CREATE_SAFETY_DOCUMENT,
  SET_SAFETY_REPORT,
  SET_SAFETY_CONFIGS,
  CREATE_SAFETY_CONFIG,
  UPDATE_SAFETY_CONFIG,
  DELETE_SAFETY_CONFIG
} from '../constants/safety';
import {
  getSafetyProjectsWithPagination,
  createSafetyProject,
  updateSafetyProject,
  deleteSafetyProject,
  getDailyFormsWithPagination,
  getDailyForm,
  createDailyForm,
  updateDailyForm,
  getSkyclimberFormsWithPagination,
  getSkyclimberForm,
  createSkyclimberForm,
  updateSkyclimberForm,
  getToolboxTalksWithPagination,
  uploadToolboxTalk,
  updateToolboxTalk,
  getSafetyDocumentsWithPagination,
  uploadSafetyDocument,
  updateSafetyDocument,
  getDailyFormsReport,
  getSkyclimberReport,
  getToolboxTalksReport,
  getSafetyConfigs,
  createSafetyConfig,
  updateSafetyConfig,
  deleteSafetyConfig
} from '../../services/safety';
import { setSuccessMessage } from './common';

// Safety Projects
export const fetchSafetyProjects = (reqData) => async (dispatch) => {
  try {
    const res = await getSafetyProjectsWithPagination(reqData);
    dispatch({ type: SET_SAFETY_PROJECTS, payload: res.data });
  } catch (err) {}
};

export const addSafetyProject = (data, cb) => async (dispatch, getState) => {
  try {
    const res = await createSafetyProject(data);
    const current = getState().safety.safetyProjects;
    dispatch({
      type: CREATE_SAFETY_PROJECT,
      payload: { ...current, data: [...(current?.data || []), res.data] }
    });
    dispatch(setSuccessMessage('Safety project created successfully'));
    cb();
  } catch (err) {}
};

export const editSafetyProject = (id, data, cb) => async (dispatch, getState) => {
  try {
    const res = await updateSafetyProject(id, data);
    const projects = [...(getState().safety.safetyProjects?.data || [])];
    const index = projects.findIndex((p) => p.id === id);
    projects[index] = res.data;
    dispatch({
      type: UPDATE_SAFETY_PROJECT,
      payload: { ...getState().safety.safetyProjects, data: projects }
    });
    dispatch(setSuccessMessage('Safety project updated successfully'));
    cb();
  } catch (err) {}
};

export const removeSafetyProject = (id) => async (dispatch, getState) => {
  try {
    await deleteSafetyProject(id);
    const projects = [...(getState().safety.safetyProjects?.data || [])];
    const index = projects.findIndex((p) => p.id === id);
    projects.splice(index, 1);
    dispatch({
      type: DELETE_SAFETY_PROJECT,
      payload: { ...getState().safety.safetyProjects, data: projects }
    });
    dispatch(setSuccessMessage('Safety project deleted successfully'));
  } catch (err) {}
};

// Daily Forms
export const fetchDailyForms = (reqData) => async (dispatch) => {
  try {
    const res = await getDailyFormsWithPagination(reqData);
    dispatch({ type: SET_DAILY_FORMS, payload: res.data });
  } catch (err) {}
};

export const fetchDailyFormDetail = (id) => async (dispatch) => {
  try {
    const res = await getDailyForm(id);
    dispatch({ type: SET_DAILY_FORM_DETAIL, payload: res.data });
  } catch (err) {}
};

export const addDailyForm = (data, cb) => async (dispatch) => {
  try {
    await createDailyForm(data);
    dispatch(setSuccessMessage('Daily form created successfully'));
    cb();
  } catch (err) {}
};

export const editDailyForm = (id, data, cb) => async (dispatch) => {
  try {
    await updateDailyForm(id, data);
    dispatch(setSuccessMessage('Daily form updated successfully'));
    cb();
  } catch (err) {}
};

// Skyclimber Forms
export const fetchSkyclimberForms = (reqData) => async (dispatch) => {
  try {
    const res = await getSkyclimberFormsWithPagination(reqData);
    dispatch({ type: SET_SKYCLIMBER_FORMS, payload: res.data });
  } catch (err) {}
};

export const fetchSkyclimberFormDetail = (id) => async (dispatch) => {
  try {
    const res = await getSkyclimberForm(id);
    dispatch({ type: SET_SKYCLIMBER_FORM_DETAIL, payload: res.data });
  } catch (err) {}
};

export const addSkyclimberForm = (data, cb) => async (dispatch) => {
  try {
    await createSkyclimberForm(data);
    dispatch(setSuccessMessage('Skyclimber form created successfully'));
    cb();
  } catch (err) {}
};

export const editSkyclimberForm = (id, data, cb) => async (dispatch) => {
  try {
    await updateSkyclimberForm(id, data);
    dispatch(setSuccessMessage('Skyclimber form updated successfully'));
    cb();
  } catch (err) {}
};

// Toolbox Talks
export const fetchToolboxTalks = (reqData) => async (dispatch) => {
  try {
    const res = await getToolboxTalksWithPagination(reqData);
    dispatch({ type: SET_TOOLBOX_TALKS, payload: res.data });
  } catch (err) {}
};

export const addToolboxTalk = (formData, cb) => async (dispatch, getState) => {
  try {
    const res = await uploadToolboxTalk(formData);
    const current = getState().safety.toolboxTalks;
    dispatch({
      type: CREATE_TOOLBOX_TALK,
      payload: { ...current, data: [...(current?.data || []), res.data] }
    });
    dispatch(setSuccessMessage('Toolbox talk uploaded successfully'));
    cb();
  } catch (err) {}
};

export const editToolboxTalk = (id, data, cb) => async (dispatch, getState) => {
  try {
    const res = await updateToolboxTalk(id, data);
    const talks = [...(getState().safety.toolboxTalks?.data || [])];
    const index = talks.findIndex((t) => t.id === id);
    talks[index] = res.data;
    dispatch({
      type: UPDATE_TOOLBOX_TALK,
      payload: { ...getState().safety.toolboxTalks, data: talks }
    });
    dispatch(setSuccessMessage('Toolbox talk updated successfully'));
    cb();
  } catch (err) {}
};

// Safety Documents
export const fetchSafetyDocuments = (reqData) => async (dispatch) => {
  try {
    const res = await getSafetyDocumentsWithPagination(reqData);
    dispatch({ type: SET_SAFETY_DOCUMENTS, payload: res.data });
  } catch (err) {}
};

export const addSafetyDocument = (formData, cb) => async (dispatch, getState) => {
  try {
    const res = await uploadSafetyDocument(formData);
    const current = getState().safety.safetyDocuments;
    dispatch({
      type: CREATE_SAFETY_DOCUMENT,
      payload: { ...current, data: [...(current?.data || []), res.data] }
    });
    dispatch(setSuccessMessage('Document uploaded successfully'));
    cb();
  } catch (err) {}
};

export const editSafetyDocument = (id, data, cb) => async (dispatch, getState) => {
  try {
    const res = await updateSafetyDocument(id, data);
    const docs = [...(getState().safety.safetyDocuments?.data || [])];
    const index = docs.findIndex((d) => d.id === id);
    docs[index] = res.data;
    dispatch({
      type: UPDATE_SAFETY_DOCUMENT,
      payload: { ...getState().safety.safetyDocuments, data: docs }
    });
    dispatch(setSuccessMessage('Document updated successfully'));
    cb();
  } catch (err) {}
};

// Reports
export const fetchSafetyReport = (reportType, reqData) => async (dispatch) => {
  try {
    const fetchers = {
      dailyForms: getDailyFormsReport,
      skyclimber: getSkyclimberReport,
      toolboxTalks: getToolboxTalksReport
    };
    const res = await fetchers[reportType](reqData);
    dispatch({ type: SET_SAFETY_REPORT, payload: res.data });
  } catch (err) {}
};

// Safety Config
export const fetchSafetyConfigs = () => async (dispatch) => {
  try {
    const res = await getSafetyConfigs();
    dispatch({ type: SET_SAFETY_CONFIGS, payload: res.data });
  } catch (err) {}
};

export const addSafetyConfig = (data, cb) => async (dispatch, getState) => {
  try {
    const res = await createSafetyConfig(data);
    const current = getState().safety.safetyConfigs || [];
    dispatch({
      type: CREATE_SAFETY_CONFIG,
      payload: [...current, res.data].sort((a, b) => a.key.localeCompare(b.key))
    });
    dispatch(setSuccessMessage('Safety config created successfully'));
    cb();
  } catch (err) {}
};

export const editSafetyConfig = (id, data, cb) => async (dispatch, getState) => {
  try {
    const res = await updateSafetyConfig(id, data);
    const configs = [...(getState().safety.safetyConfigs || [])];
    const index = configs.findIndex((config) => config.id === id);
    configs[index] = res.data;
    dispatch({
      type: UPDATE_SAFETY_CONFIG,
      payload: configs.sort((a, b) => a.key.localeCompare(b.key))
    });
    dispatch(setSuccessMessage('Safety config updated successfully'));
    cb();
  } catch (err) {}
};

export const removeSafetyConfig = (id) => async (dispatch, getState) => {
  try {
    await deleteSafetyConfig(id);
    const configs = [...(getState().safety.safetyConfigs || [])];
    const index = configs.findIndex((config) => config.id === id);
    configs.splice(index, 1);
    dispatch({
      type: DELETE_SAFETY_CONFIG,
      payload: configs
    });
    dispatch(setSuccessMessage('Safety config deleted successfully'));
  } catch (err) {}
};
